'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Types = require('../types/Types');

var _Types2 = _interopRequireDefault(_Types);

var _ChangeRequest = require('../change/ChangeRequest');

var _ChangeRequest2 = _interopRequireDefault(_ChangeRequest);

var _last = require('unmutable/lib/last');

var _last2 = _interopRequireDefault(_last);

var _update = require('unmutable/lib/update');

var _update2 = _interopRequireDefault(_update);

var _pipeWith = require('unmutable/lib/util/pipeWith');

var _pipeWith2 = _interopRequireDefault(_pipeWith);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_this) {
    return {
        _buffer: function _buffer(changeRequest) {
            var initialBuffer = changeRequest ? changeRequest.updateActions(function () {
                return [];
            }) // TODO - if changeRequest implements caching, is this enough data clearing?
            : null;

            _this._dispatchBuffer.push(initialBuffer);
        },

        _flush: function _flush() {
            _this.dispatch(_this._dispatchBuffer.pop());
        },

        _handleChange: function _handleChange(_onHandleChange, changeRequest) {
            var parcel = _this._create({
                parcelData: changeRequest.setBaseParcel(_this).data()
            });

            _onHandleChange(parcel, changeRequest);
        },

        dispatch: function dispatch(dispatchable) {
            (0, _Types2.default)('dispatch() expects param "dispatchable" to be', 'dispatchable')(dispatchable);

            var _onDispatch = _this._onDispatch,
                _onHandleChange = _this._onHandleChange;


            _this._treeshare.dispatch.markPathAsDispatched(_this.path());

            var changeRequest = dispatchable instanceof _ChangeRequest2.default ? dispatchable : new _ChangeRequest2.default(dispatchable);

            if (!changeRequest._originId) {
                changeRequest._originId = _this.id();
                changeRequest._originPath = _this.path();
            }

            if (_this._dispatchBuffer.length > 0) {
                _this._dispatchBuffer = (0, _pipeWith2.default)(_this._dispatchBuffer, (0, _update2.default)(-1, function (cc) {
                    return (cc || new _ChangeRequest2.default()).merge(changeRequest);
                }));

                _this._parcelData = changeRequest.setBaseParcel(_this).data();

                return;
            }

            if (_onHandleChange) {
                _this._handleChange(_onHandleChange, changeRequest);
                return;
            }
            _onDispatch && _onDispatch(changeRequest);
        },

        batch: function batch(batcher, changeRequest) {
            (0, _Types2.default)('batch() expects param "batcher" to be', 'function')(batcher);
            _this._buffer(changeRequest);
            batcher(_this);

            var shouldFlush = (0, _pipeWith2.default)(_this._dispatchBuffer, (0, _last2.default)(), function (cc) {
                return cc && cc.actions().length > 0;
            });

            if (shouldFlush) {
                _this._flush();
            } else {
                _this._dispatchBuffer.pop();
            }
        }
    };
};


//////////////////
// WEBPACK FOOTER
// ./~/parcels/lib/parcel/ActionMethods.js
// module id = 737
// module chunks = 35783957827783